<mat-card class="all-devices">
  <mat-card-header class="card-header card-header-datatype">
    <div class="container">
      <mat-card-title>
        <div class="row">
          <div class="col-3" *ngIf="parent">
            <mat-icon
              (click)="goBackButton(parent)"
              class="pointer unselectable verticalCenteredIcon"
            >
              keyboard_arrow_left</mat-icon
            >
          </div>
          <div [@fadeInOut] class="col-6">
            {{ parent?.name }}
          </div>
          <div class="col-3"></div>
        </div>
      </mat-card-title>
    </div>
  </mat-card-header>
  <mat-card-content class="card-content-datatype">
    <div *ngIf="!loading">
      <div *ngIf="!hasChildren(itemCollection)">
        <div class="container mtop5">
          <div class="text-center">
            <h4>{{ "WARNING_MESSAGES.NO_DEVICES" | translate }}</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="dispositivos" *ngFor="let item of itemCollection">
      <mat-card class="card-dispositivos">
        <mat-card-header
          class="card-header-dispositivos"
          [ngClass]="!buttonActive ? ' effectSelectDevice' : ''"
        >
          <div class="container">
            <div
              [ngClass]="
                item?.selectedState === 'notSelectable' ? 'disabledDevice' : ''
              "
              class="row"
            >
              <div mat-card-avatar class="col-md-2 margen-dispositivos-alarma">
                <app-blue-icon name="data-type"></app-blue-icon>
              </div>
              <div class="col-md-7 nombre-dispositivo">
                <!-- <mat-card-title>{{item?.root?.name}}</mat-card-title>
                              <mat-card-title>{{item?.name}}</mat-card-title> -->
                <mat-card-title *ngIf="item?.root?.name">
                  {{ item?.root?.name }}
                </mat-card-title>
                <mat-card-title>
                  {{ item?.name }}
                </mat-card-title>
                <!-- <mat-card-title>{{item?.selectedState}}</mat-card-title> -->
              </div>
              <div class="col-md-3 pull-right">
                <div *ngIf="buttonActive">
                  <div
                    *ngIf="
                      item?.selectedState != 'notSelectable';
                      else notCompatible
                    "
                  >
                    <button
                      type="button"
                      *ngIf="item.unity"
                      mat-icon-button
                      (click)="onClickItem(item)"
                    >
                      <mat-icon
                        *ngIf="item?.selectedState == 'selectable'"
                        class="icono-preview colorGreen marginTop8"
                      >
                        <app-svg
                          [name]="actionIcon"
                          width="5"
                          height="5"
                        ></app-svg>
                      </mat-icon>
                      <mat-icon
                        *ngIf="item?.selectedState == 'selected'"
                        class="icono-preview colorRed marginTop8"
                      >
                        <app-svg
                          name="remove-circle"
                          width="5"
                          height="5"
                        ></app-svg>
                      </mat-icon>
                    </button>
                  </div>

                  <button
                    type="button"
                    *ngIf="!item.unity"
                    mat-icon-button
                    (click)="onClickItemNavegate(item)"
                  >
                    <mat-icon
                      class="icono-preview colorGreenHighlight navigate"
                    >
                      <app-svg
                        name="circle-right"
                        width="5"
                        height="5"
                      ></app-svg>
                    </mat-icon>
                  </button>

                  <ng-template #notCompatible>
                    <button
                      type="button"
                      disabled
                      mat-icon-button
                      (click)="onClickItem(item)"
                      title="Este tipo de dato no coincide en unidad"
                    >
                      <mat-icon
                        class="icono-preview colorGreenHighlight marginTop8"
                      >
                        <div class="icono-checked">
                          <app-svg name="done"></app-svg>
                        </div>
                      </mat-icon>
                    </button>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </mat-card-header>
      </mat-card>
    </div>
  </mat-card-content>
</mat-card>
